export enum RestrictedNhsDataReason {
    None = 1,
    PatientNotRegistered,
    NoCqcOrganization,
    PatientPassport
}
